import { Observable, BehaviorSubject } from 'rxjs'
import { ToggleClass } from 'core/toggleClass';
import { EnterSearchObserver } from '../search/enterSearch.observer'

export class ErrorComponent {
    constructor() {
        this.detail = document.querySelectorAll('[data-click="show-error"]')
        this.content = document.querySelector('.error__detail-content')
        this.search = document.querySelector('[data-search="page-error"]')
        this.enterStream = Observable.fromEvent(this.search, 'keyup')
        this.enterSubject = new BehaviorSubject()
        this.init()
    }

    init() {
        if (this.detail) {
            new ToggleClass(this.modalSettings())
        }
        if (this.search) {
            this.enterSubject.subscribe(new EnterSearchObserver())
            this.enterStream
                .filter(e => e.keyCode === 13)
                .map(e => e.target.value)
                .subscribe(termo => this.enterSubject.next(termo))
        }
    }

    modalSettings() {
        return {
            selector: this.detail,
            target: this.content,
            class: 'error__detail-content--actived'
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/error/error.component.js